export default {"src":"/_next/static/media/video.c02c4644.svg","height":676,"width":1150,"blurWidth":0,"blurHeight":0};